// extracted by mini-css-extract-plugin
module.exports = {"farmfeed-filter":"farmfeed-filter___nulUv","opened":"opened___3XKAl"};